.pictogram {
  display: inline-block;
  vertical-align: middle;
  line-height: 1;
  color: var(--text);
}

.pictogram svg {
  display: block;
}

.image {
  display: inline-block;
  vertical-align: middle;
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
  -webkit-user-drag: none;
}

/* Rustige set (thema Volwassen): lijn in de pictogramkleur van het thema, standaard de tekst. */
.clean {
  display: inline-block;
  vertical-align: middle;
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
  color: var(--picto-ink, currentColor);
  overflow: visible;
}

.letter {
  border-radius: 28%;
  background: var(--surface-sunken);
  color: var(--text-muted);
  font-weight: var(--fw-650);
  text-align: center;
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: inline-flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
}

/* Avond/nacht: pictogrammen die nog donkere lijnen hebben (OpenMoji, oude eigen stijl) krijgen een
   zacht plaatje dat ze leesbaar houdt. UX-ronde bord: gedempt warm grijs in plaats van bijna wit,
   zodat de plaatjes niet het felste van het scherm zijn (de zwarte lijnen blijven ruim zichtbaar:
   10:1). De eigen set (docs/ux/pictogrammen.md) heeft geen plaatje nodig. */
[data-theme='dark'] .darkLine,
[data-theme='night'] .darkLine {
  padding: var(--picto-pad, 4px);
  border-radius: 28%;
  background: #c9c3b8;
}

[data-theme='night'] .image {
  opacity: 0.6;
}
